import { performFetch } from './utils'

export function loadCrewTypes() {
    return performFetch({ type: 'LOAD_CREW_TYPES' })
}

export function loadInsuranceTypes() {
    return performFetch({ type: 'LOAD_INSURANCE_TYPES' })
}

export function loadVehicleTypes() {
    return performFetch({ type: 'LOAD_VEHICLE_TYPES' })
}

export function loadVehicleMakes() {
    return performFetch({ type: 'LOAD_VEHICLE_MAKES' })
}

export function loadIndustryTypes() {
    return performFetch({ type: 'LOAD_INDUSTRY_TYPES' })
}

export function loadLanguages() {
    return performFetch({ type: 'LOAD_LANGUAGES' })
}



// WEBPACK FOOTER //
// ./app/actions/crew.js